<div class="outer-container">

  @if (labelBefore) {
    <div class="label-container">
      <lib-text-common class="label left">{{ label }}</lib-text-common>
    </div>
  }

  @if (useSlider) {
    <lib-vitu-slide-toggle
      class="slider"
      [checked]="checked"
      (checkedChange)="onToggled($event)"
      [disabled]="disabled">
    </lib-vitu-slide-toggle>
  }

  @if (!useSlider) {
    <mat-checkbox
      #checkbox
      class="checkbox"
      [checked]="checked"
      (change)="onToggled(checkbox.checked)"
      [disabled]="disabled">
    </mat-checkbox>
  }

  @if (!labelBefore) {
    <div class="label-container">
      <lib-text-common class="label right">{{ label }}</lib-text-common>
    </div>
  }

</div>
